import React from "react";
import Header from "../../panels/Header";
import UserAvatar from "../../panels/UserAvatar";
import styles from "./HeaderWithLogout.style";
import {setActiveAlert} from "../../redux/actions/alertsActions";
import ConfirmLogoutAlert from "../../alerts/ConfirmLogoutAlert";
import {connect} from "react-redux";


const HeaderWithLogout = ({showConfirmLogoutAlert, userInfo}) => {
  return (
    <>
      <Header/>
      <UserAvatar userInfo={userInfo}/>
      <button
        type="button"
        onClick={showConfirmLogoutAlert}
        style={styles.buttonLogout}
      >
        Выйти
      </button>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo.userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showConfirmLogoutAlert: () =>
      dispatch(setActiveAlert(<ConfirmLogoutAlert />)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWithLogout);
